import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="bg-white">
      <div className="mx-auto max-w-3xl px-6 py-32 text-center">
        <p className="font-display text-[96px] leading-none text-[#0A1128]">404</p>
        <h1 className="font-display mt-4 text-[28px] text-[#0A1128]">Page not found</h1>
        <p className="mt-3 text-slate-600">The page you&apos;re looking for doesn&apos;t exist or has moved.</p>
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#0A1128] text-white text-[14px] font-medium px-5 py-3"
        >
          Back to home
        </Link>
      </div>
    </section>
  );
}
